import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Grid, MenuItem, TextField, makeStyles, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import BackPage from '../../components/BackPage/BackPage.component';
import CustomerInfo from '../../components/CustomerInfo/CustomerInfo.component';
import CustomerStats from '../../components/CustomerStats/CustomerStats.component';
import PageContainer from '../../components/PageContainer/PageContainer.component';
import RedemptionsTable from '../../components/RedemptionsTable/RedemptionsTable.component';
import ReferralReport from '../../components/ReferralReport/ReferralReport.component';
import { IBar } from '../../models/IBars';
import { ICustomer, ICustomerReport } from '../../models/ICustomers';

const DUMMY_POINTS_REDEMPTIONS = [
    {
        name: "Bar name",
        numberOfRewards: "15",
        amountSpent: "$215"
    },
    {
        name: "Bar name",
        numberOfRewards: "15",
        amountSpent: "$215"
    },
    {
        name: "Bar name",
        numberOfRewards: "15",
        amountSpent: "$215"
    },
];

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        heading: {
            color: '#fff',
            marginBottom: theme.spacing(2),
        },
        label: {
            fontWeight: 'bold'
        },
        deleteFab: {
            backgroundColor: '#fff',
            color: 'red',
        },
        table: {
            // minWidth: 650,
            overflow: "scroll"
        },
        manualPointsButton: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        }
    })
);

interface Props {
    entry: ICustomer,
    report: ICustomerReport,
    onDeleteClick: () => void,
    onGivePointsClick: () => void,
    isGrantingPoints: boolean,
    isPointsDialogOpen: boolean,
    pointsInput: string,
    pointsInputError: string,
    pointsBars: IBar[],
    isBarsLoading: boolean,
    selectedPointsBarId: string,
    onPointsInputChange: (value: string) => void,
    onPointsBarChange: (value: string) => void,
    onClosePointsDialog: () => void,
    onSubmitPointsDialog: () => void
}

export default function CustomerDetailsPage({
    report,
    entry,
    onDeleteClick,
    onGivePointsClick,
    isGrantingPoints,
    isPointsDialogOpen,
    pointsInput,
    pointsInputError,
    pointsBars,
    isBarsLoading,
    selectedPointsBarId,
    onPointsInputChange,
    onPointsBarChange,
    onClosePointsDialog,
    onSubmitPointsDialog
}: Props) {
    const classes = useStyles();

    return (
        <BackPage>
            <PageContainer>
                <Grid container direction="column">
                    <Grid item>
                        <Grid className={classes.heading} container direction="row">
                            <Grid xs item>
                                <Typography variant="h5">
                                    Customer Details
                            </Typography>
                            </Grid>
                            <Grid item>
                                <Fab className={classes.deleteFab} size="medium" aria-label="delete" onClick={onDeleteClick}>
                                    <DeleteIcon />
                                </Fab>
                            </Grid>
                        </Grid>
                        <CustomerInfo
                            data={entry}
                        />
                        <Button
                            className={classes.manualPointsButton}
                            variant="contained"
                            color="primary"
                            disabled={isGrantingPoints}
                            onClick={onGivePointsClick}
                        >
                            {isGrantingPoints ? "Granting..." : "Give Points"}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.heading} variant="h5">
                            Money, Points & rewards
                    </Typography>
                        <CustomerStats
                            data={report}
                        />
                    </Grid>
                    <Grid item>
                        <Typography className={classes.heading} variant="h5">
                            Where points were redeemed
                    </Typography>
                        <RedemptionsTable
                            data={report?.barsData}
                        />
                    </Grid>
                    <Grid item>
                        <Typography className={classes.heading} variant="h5">
                            Referral Report
                        </Typography>
                        <ReferralReport referrerUserId={entry?.id} />
                    </Grid>
                </Grid>
            </PageContainer>
            <Dialog open={isPointsDialogOpen} onClose={onClosePointsDialog} fullWidth maxWidth="xs">
                <DialogTitle>Give Points</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="Bar"
                        select
                        value={selectedPointsBarId}
                        onChange={(event) => onPointsBarChange(event.target.value as string)}
                        fullWidth
                        disabled={isGrantingPoints || isBarsLoading}
                        helperText={isBarsLoading ? "Loading bars..." : "Choose where points should apply."}
                    >
                        <MenuItem value="manual">Manual / No specific bar</MenuItem>
                        {pointsBars.map((bar) => (
                            <MenuItem key={bar.id} value={bar.id}>
                                {bar.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Points"
                        type="number"
                        value={pointsInput}
                        onChange={(event) => onPointsInputChange(event.target.value)}
                        error={!!pointsInputError}
                        helperText={pointsInputError}
                        fullWidth
                        inputProps={{ min: 1, step: 1 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClosePointsDialog} disabled={isGrantingPoints}>
                        Cancel
                    </Button>
                    <Button color="primary" variant="contained" onClick={onSubmitPointsDialog} disabled={isGrantingPoints}>
                        {isGrantingPoints ? "Granting..." : "Grant Points"}
                    </Button>
                </DialogActions>
            </Dialog>
        </BackPage>
    )
}
